import * as React from 'react';
import GlobalStyles from '@mui/joy/GlobalStyles';
import Box from '@mui/joy/Box';
import Divider from '@mui/joy/Divider';
import IconButton from '@mui/joy/IconButton';
import List from '@mui/joy/List';
import ListItem from '@mui/joy/ListItem';
import ListItemButton, { listItemButtonClasses } from '@mui/joy/ListItemButton';
import ListItemContent from '@mui/joy/ListItemContent';
import Typography from '@mui/joy/Typography';
import Sheet from '@mui/joy/Sheet';
import BrightnessAutoRoundedIcon from '@mui/icons-material/BrightnessAutoRounded';
import AdUnitsRoundedIcon from '@mui/icons-material/AdUnitsRounded';
import AppsRoundedIcon from '@mui/icons-material/AppsRounded';

import ColorSchemeToggle from './ColorSchemeToggle';
import { closeSidebar } from '../utils';
import { useNavigate } from 'react-router-dom';

// function Toggler({
//   defaultExpanded = false,
//   renderToggle,
//   children,
// }: {
//   defaultExpanded?: boolean;
//   children: React.ReactNode;
//   renderToggle: (params: {
//     open: boolean;
//     setOpen: React.Dispatch<React.SetStateAction<boolean>>;
//   }) => React.ReactNode;
// }) {
//   const [open, setOpen] = React.useState(defaultExpanded);
//   return (
//     <React.Fragment>
//       {renderToggle({ open, setOpen })}
//       <Box
//         sx={[
//           {
//             display: 'grid',
//             transition: '0.2s ease',
//             '& > *': {
//               overflow: 'hidden',
//             },
//           },
//           open ? { gridTemplateRows: '1fr' } : { gridTemplateRows: '0fr' },
//         ]}
//       >
//         {children}
//       </Box>
//     </React.Fragment>
//   );
// }

export default function Sidebar() {
  const navigate = useNavigate();
  return (
    <Sheet
      className="Sidebar"
      sx={{
        position: { xs: 'fixed', md: 'sticky' },
        transform: {
          xs: 'translateX(calc(100% * (var(--SideNavigation-slideIn, 0) - 1)))',
          md: 'none',
        },
        transition: 'transform 0.4s, width 0.4s',
        zIndex: 10000,
        height: '100dvh',
        width: 'var(--Sidebar-width)',
        top: 0,
        p: 2,
        flexShrink: 0,
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        borderRight: '1px solid',
        borderColor: 'divider',
      }}
    >
      <GlobalStyles
        styles={(theme) => ({
          ':root': {
            '--Sidebar-width': '220px',
            [theme.breakpoints.up('lg')]: {
              '--Sidebar-width': '240px',
            },
          },
        })}
      />
      <Box
        className="Sidebar-overlay"
        sx={{
          position: 'fixed',
          zIndex: 9998,
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          opacity: 'var(--SideNavigation-slideIn)',
          backgroundColor: 'var(--joy-palette-background-backdrop)',
          transition: 'opacity 0.4s',
          transform: {
            xs: 'translateX(calc(100% * (var(--SideNavigation-slideIn, 0) - 1) + var(--SideNavigation-slideIn, 0) * var(--Sidebar-width, 0px)))',
            lg: 'translateX(-100%)',
          },
        }}
        onClick={() => closeSidebar()}
      />
      <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
        <IconButton variant="soft" color="primary" size="sm">
          <BrightnessAutoRoundedIcon />
        </IconButton>
        {/* ---- change this to "ATOSA Mexico" if needed ---- */}
        <Typography level="title-lg">ATOSA USA</Typography>
        <ColorSchemeToggle sx={{ ml: 'auto' }} />
      </Box>
      <Box
        sx={{
          minHeight: 0,
          overflow: 'hidden auto',
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          [`& .${listItemButtonClasses.root}`]: {
            gap: 1.5,
          },
        }}
      >
        <List
          size="sm"
          sx={{
            gap: 1,
            '--List-nestedInsetStart': '30px',
            '--ListItem-radius': (theme) => theme.vars.radius.sm,
          }}
        >
        <Divider />
          <ListItem>
            <ListItemButton onClick={() => navigate('/units/')}>
              <AdUnitsRoundedIcon />
              <ListItemContent>
                <Typography level="title-sm">Units</Typography>
              </ListItemContent>
            </ListItemButton>
          </ListItem>

          <ListItem>
            <ListItemButton onClick={() => navigate('/parts/')}>
              <AppsRoundedIcon />
              <ListItemContent>
                <Typography level="title-sm">Parts</Typography>
              </ListItemContent>
            </ListItemButton>
          </ListItem>
        </List>
      </Box>
      
    </Sheet>
  );
}